import { decodeHexResponse } from '../_common/common.utils';
import DashboardTypes from './dashboard.types';

const INITIAL_STATE = {
	dashboardData: null,
	employeeListEnhancedData: null,
	checkedInCardEmployeeListData: null,
	activeEmployeesCardEmployeeListData: null,
	lateCheckInCardEmployeeListData: null,
	earlyCheckOutCardEmployeeListData: null,
	onLeaveCardEmployeeListData: null,
	absentCardEmployeeListData: null,
	activeEmployeesCardData: null,
	checkedInCardData: null,
	lateCheckInCardData: null,
	earlyCheckOutCardData: null,
	onLeaveCardData: null,
	absentCardData: null,
	// Loading states for each card
	activeEmployeesCardLoading: false,
	checkedInCardLoading: false,
	lateCheckInCardLoading: false,
	earlyCheckOutCardLoading: false,
	onLeaveCardLoading: false,
	absentCardLoading: false,
};

const dashboardReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case DashboardTypes.DASHBOARD_START:
			return { ...state, dashboardData: null };
		case DashboardTypes.DASHBOARD_SUCCESS:
			return {
				...state,
				dashboardData: decodeHexResponse(action.payload, 'fetchSectionWiseDataKey'),
			};
		case DashboardTypes.DASHBOARD_FAILURE:
			return {
				...state,
				dashboardData: decodeHexResponse(action.payload, 'fetchSectionWiseDataKey'),
			};
		case DashboardTypes.DASHBOARD_RESPONSE_CHANGED:
			return { ...state, dashboardData: null };
		case DashboardTypes.DASHBOARD_RESPONSE_REST_START:
			return { ...state, dashboardData: null };
		// Enhanced Employee List Cases
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_START:
			return { ...state, employeeListEnhancedData: null };
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_SUCCESS:
			return {
				...state,
				employeeListEnhancedData: decodeHexResponse(
					action.payload,
					'fetchEmployeeListEnhancedKey',
				),
			};
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_FAILURE:
			return {
				...state,
				employeeListEnhancedData: decodeHexResponse(
					action.payload,
					'fetchEmployeeListEnhancedKey',
				),
			};
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_RESPONSE_CHANGED:
			return { ...state, employeeListEnhancedData: null };
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_RESPONSE_REST_START:
			return { ...state, employeeListEnhancedData: null };
		// Checked In Card Employee List Cases
		case DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_START:
			return { ...state, checkedInCardEmployeeListData: null };
		case DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_SUCCESS:
			return {
				...state,
				checkedInCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetCheckedInCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_FAILURE:
			return {
				...state,
				checkedInCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetCheckedInCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED:
			return { ...state, checkedInCardEmployeeListData: null };
		case DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_RESPONSE_REST_START:
			return { ...state, checkedInCardEmployeeListData: null };
		// Active Employees Card Employee List Cases
		case DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_START:
			return { ...state, activeEmployeesCardEmployeeListData: null };
		case DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_SUCCESS:
			return {
				...state,
				activeEmployeesCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetActiveEmployeesCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_FAILURE:
			return {
				...state,
				activeEmployeesCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetActiveEmployeesCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED:
			return { ...state, activeEmployeesCardEmployeeListData: null };
		case DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_RESPONSE_REST_START:
			return { ...state, activeEmployeesCardEmployeeListData: null };
		// Late Check In Card Employee List Cases
		case DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_START:
			return { ...state, lateCheckInCardEmployeeListData: null };
		case DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_SUCCESS:
			return {
				...state,
				lateCheckInCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetLateCheckInCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_FAILURE:
			return {
				...state,
				lateCheckInCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetLateCheckInCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED:
			return { ...state, lateCheckInCardEmployeeListData: null };
		case DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_RESPONSE_REST_START:
			return { ...state, lateCheckInCardEmployeeListData: null };
		// Early Check Out Card Employee List Cases
		case DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_START:
			return { ...state, earlyCheckOutCardEmployeeListData: null };
		case DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_SUCCESS:
			return {
				...state,
				earlyCheckOutCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetEarlyCheckOutCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_FAILURE:
			return {
				...state,
				earlyCheckOutCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetEarlyCheckOutCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED:
			return { ...state, earlyCheckOutCardEmployeeListData: null };
		case DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_RESPONSE_REST_START:
			return { ...state, earlyCheckOutCardEmployeeListData: null };
		// On Leave Card Employee List Cases
		case DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_START:
			return { ...state, onLeaveCardEmployeeListData: null };
		case DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_SUCCESS:
			return {
				...state,
				onLeaveCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetOnLeaveCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_FAILURE:
			return {
				...state,
				onLeaveCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetOnLeaveCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED:
			return { ...state, onLeaveCardEmployeeListData: null };
		case DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_RESPONSE_REST_START:
			return { ...state, onLeaveCardEmployeeListData: null };
		// Absent Card Employee List Cases
		case DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_START:
			return { ...state, absentCardEmployeeListData: null };
		case DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_SUCCESS:
			return {
				...state,
				absentCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetAbsentCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_FAILURE:
			return {
				...state,
				absentCardEmployeeListData: decodeHexResponse(
					action.payload,
					'GetAbsentCardEmployeeListFromWeb',
				),
			};
		case DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED:
			return { ...state, absentCardEmployeeListData: null };
		case DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_RESPONSE_REST_START:
			return { ...state, absentCardEmployeeListData: null };
		// Dashboard Card Cases
		case DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_START:
			return { ...state, activeEmployeesCardData: null, activeEmployeesCardLoading: true };
		case DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_SUCCESS:
			return {
				...state,
				activeEmployeesCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_KEY,
				),
				activeEmployeesCardLoading: false,
			};
		case DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_FAILURE:
			return {
				...state,
				activeEmployeesCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_KEY,
				),
				activeEmployeesCardLoading: false,
			};
		case DashboardTypes.GET_CHECKED_IN_CARD_START:
			return { ...state, checkedInCardData: null, checkedInCardLoading: true };
		case DashboardTypes.GET_CHECKED_IN_CARD_SUCCESS:
			return {
				...state,
				checkedInCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_CHECKED_IN_CARD_KEY,
				),
				checkedInCardLoading: false,
			};
		case DashboardTypes.GET_CHECKED_IN_CARD_FAILURE:
			return {
				...state,
				checkedInCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_CHECKED_IN_CARD_KEY,
				),
				checkedInCardLoading: false,
			};
		case DashboardTypes.GET_LATE_CHECK_IN_CARD_START:
			return { ...state, lateCheckInCardData: null, lateCheckInCardLoading: true };
		case DashboardTypes.GET_LATE_CHECK_IN_CARD_SUCCESS:
			return {
				...state,
				lateCheckInCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_LATE_CHECK_IN_CARD_KEY,
				),
				lateCheckInCardLoading: false,
			};
		case DashboardTypes.GET_LATE_CHECK_IN_CARD_FAILURE:
			return {
				...state,
				lateCheckInCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_LATE_CHECK_IN_CARD_KEY,
				),
				lateCheckInCardLoading: false,
			};
		case DashboardTypes.GET_EARLY_CHECK_OUT_CARD_START:
			return { ...state, earlyCheckOutCardData: null, earlyCheckOutCardLoading: true };
		case DashboardTypes.GET_EARLY_CHECK_OUT_CARD_SUCCESS:
			return {
				...state,
				earlyCheckOutCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_EARLY_CHECK_OUT_CARD_KEY,
				),
				earlyCheckOutCardLoading: false,
			};
		case DashboardTypes.GET_EARLY_CHECK_OUT_CARD_FAILURE:
			return {
				...state,
				earlyCheckOutCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_EARLY_CHECK_OUT_CARD_KEY,
				),
				earlyCheckOutCardLoading: false,
			};
		case DashboardTypes.GET_ON_LEAVE_CARD_START:
			return { ...state, onLeaveCardData: null, onLeaveCardLoading: true };
		case DashboardTypes.GET_ON_LEAVE_CARD_SUCCESS:
			return {
				...state,
				onLeaveCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_ON_LEAVE_CARD_KEY,
				),
				onLeaveCardLoading: false,
			};
		case DashboardTypes.GET_ON_LEAVE_CARD_FAILURE:
			return {
				...state,
				onLeaveCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_ON_LEAVE_CARD_KEY,
				),
				onLeaveCardLoading: false,
			};
		case DashboardTypes.GET_ABSENT_CARD_START:
			return { ...state, absentCardData: null, absentCardLoading: true };
		case DashboardTypes.GET_ABSENT_CARD_SUCCESS:
			return {
				...state,
				absentCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_ABSENT_CARD_KEY,
				),
				absentCardLoading: false,
			};
		case DashboardTypes.GET_ABSENT_CARD_FAILURE:
			return {
				...state,
				absentCardData: decodeHexResponse(
					action.payload,
					DashboardTypes.GET_ABSENT_CARD_KEY,
				),
				absentCardLoading: false,
			};
		default:
			return state;
	}
};

export default dashboardReducer;
